import { Button } from "react-bootstrap";
import { inactiveCampaignWarningLabels } from "@revbox/localization";
import { useCookiesContext } from "../../../../../contexts/CookiesContext";

export default function InactiveCampaignWarning({
    isDefault,
    campaign,
    handleCampaignActivate,
}) {
  const { getLanguageAbbr } = useCookiesContext();
  const languageAbbr = getLanguageAbbr();
  const multilang = inactiveCampaignWarningLabels[languageAbbr];

    return (
        isDefault && !campaign?.ppc_active && (
            <div className="alert alert-danger">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <strong>{multilang.title}</strong> {multilang.message}
                </div>
                <Button variant="danger" onClick={handleCampaignActivate}>
                  {multilang.button}
                </Button>
              </div>
            </div>
          )
    )
}